import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { AuthInterceptor } from './helpers/auth.interceptor';

// import { ToastrModule } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes) ,
    // ToastrModule.forRoot(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    provideToastr({
      preventDuplicates: true,
      maxOpened: 1,
      timeOut: 2000
    }),
    importProvidersFrom(
      NgxSpinnerModule,
    ),
    NgxSpinnerService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideAnimations()
  ]
};
